window.DocFusion = {
	
	init: function(rowSelection){
		
		var currentListingDocType	= $("input[name='listingDocType']").val();
		var currentListingName		= $("input[name='listingName']").val();
		
		var title = Loc.g("Fusionner les documents");
		
		var options = {
			title	: title,
			width: 1250,
			buttons	: [
			{
					text : Loc.g("Fermer"), click : function(){$(this).dialog("close");}
				}],
			callback	: function(){
				if ($('#docFusionForm #fusionAvailable').val() == "Y"){
					var  btnOpt = [
						{
							text : Loc.g("Fermer"), 
							'class' : 'btn btn-default',
							click : function(){
								$(this).dialog("close");
							}
						},
						{
							text : Loc.g("Fusionner les documents"), 
							'class' : 'btn btn-primary',
							click : function(){
								$("#docFusionForm").submit();
							}
						}
					];
					MyWindow.addOption('buttons', btnOpt);
					DocFusion.prepareDocFusionForm();
				}
				MyFacture.customForm();	
			}
		};

		MyWindow.load("docs", {action:"docFusionForm",rowSelection:rowSelection,currentListingDocType:currentListingDocType}, options);
	},
	
	prepareDocFusionForm : function(){
		
		var formId = "docFusionForm";
		
		var options = {
			success: function(data) {
				var formIsOk = MyForm.processJson(data, formId);
				if(formIsOk){
				}
				
			},
			dataType: "json",
			data: {action: "recordMassFusionForm", formId:formId}
		};

		MyForm.prepare(formId, "docs", options, false);
	}
	
}

window.DocMassChase = {
	
	massChaseForm: function(rowSelection){
		
		var currentListingDocType	= $("input[name='listingDocType']").val();
		var currentListingName		= $("input[name='listingName']").val();
		
		var title = Loc.g("Relancer l'ensemble des documents par email");
		
		var options = {
			title	: title,
			width: 1250,
			close: function(){
				Listing.update(currentListingName, false);
			},
			buttons	: [
					{
						text : Loc.g("Fermer"), 
						'class' : 'btn btn-default',
						click : function(){
							$(this).dialog("close");
						}
					},
					{
						text : Loc.g("Relancer les documents"), 
						'class' : 'btn btn-primary massFormBtn', 
						click : function(){
							DocMassChase.processQueueChases();
						}
					}
				],
				callback	: function(){
					MyFacture.customForm();	
				}
		};

		MyWindow.load("docs", {action:"massChaseForm",rowSelection:rowSelection,currentListingDocType:currentListingDocType}, options);
		
	},
	
	processQueueChases: function(skipFailed){

		var skipFailed = skipFailed === undefined ? false : skipFailed;
		
		if ($('.massFormBtn').hasClass('btn-success')){
			$('.massFormBtn').removeClass('btn-success').addClass('btn-default').attr('disabled','disabled');
		}

		if (skipFailed){
			var formToProcess = $('.oneDocToChase').not('.processed').not('.processfailed').first().find('form').attr('id');
		} else {
			var formToProcess = $('.oneDocToChase').not('.processed').first().find('form').attr('id');
		}
		
		DocMassChase.processOneQueuedChase(formToProcess);
		
		if (formToProcess == undefined){
			$('.massFormBtn').addClass('btn-success').removeClass('btn-default');
			$('.massFormBtn').removeAttr('disabled');
			if ($('.processfailed').length == 0){
				$('.massFormBtn').remove();
			}
		}
	},
			
	processOneQueuedChase: function(formId){

		$("#"+formId).closest('.row').removeClass('processfailed').addClass('processing');
		
		if ($("#"+formId).position() != undefined){
			$('#popupWindow').scrollTop($("#"+formId).position().top);
		}

		var options = {
			success: function(data) {
				var formIsOk = MyForm.processJson(data, formId);
				
				if(formIsOk){
					$("#"+formId).closest('.row').removeClass('processing').addClass('processed');
				} else {
					$("#"+formId).closest('.row').removeClass('processing').addClass('processfailed');
				}
				
				DocMassChase.processQueueChases(true);
			},
			dataType: "json",
			data: {action: "recordOneDocChaseMassForm", formId:formId}
		};

		MyForm.prepare(formId, "docs", options, false);
		
		$('#'+formId).submit();

	},
	
};

window.DocMassSteps = {
	
	applyToAll: function(me){
		
		var valToApply	= me.closest('.form-group').find('.toApply').val();
		var fromApply	= me.closest('.form-group').find('.toApply').attr('toApply');
		var toApply		= fromApply + "_toApply";

		$('.oneStepToUpdate').not('.processed').find('.'+toApply).val(valToApply);
		
	},
	
	processQueueSteps: function(skipFailed){

		var skipFailed = skipFailed === undefined ? false : skipFailed;
		
		if ($('.massFormBtn').hasClass('btn-success')){
			$('.massFormBtn').removeClass('btn-success').addClass('btn-default').attr('disabled','disabled');
		}

		if (skipFailed){
			var formToProcess = $('.oneStepToUpdate').not('.processed').not('.processfailed').first().find('form').attr('id');
		} else {
			var formToProcess = $('.oneStepToUpdate').not('.processed').first().find('form').attr('id');
		}
		
		DocMassSteps.processOneQueuedStep(formToProcess);
		
		if (formToProcess == undefined){
			$('.massFormBtn').addClass('btn-success').removeClass('btn-default');
			$('.massFormBtn').removeAttr('disabled');
			if ($('.processfailed').length == 0){
				$('.massFormBtn').remove();
			}
		}
	},
			
	processOneQueuedStep: function(formId){

		$("#"+formId).closest('.row').removeClass('processfailed').addClass('processing');
		
		if ($("#"+formId).position() != undefined){
			$('#popupWindow').scrollTop($("#"+formId).position().top);
		}

		
		var options = {
			success: function(data) {
				var formIsOk = data.form.status != 'failed'; 
				
				if(formIsOk){
					$("#"+formId).closest('.row').removeClass('processing').addClass('processed');
				} else {
					$("#"+formId).closest('.row').removeClass('processing').addClass('processfailed');
				}
				
				DocMassSteps.processQueueSteps(true);
			},
			dataType: "json",
			data: {action: "recordOneDocStepMassForm", formId:formId}
		};

		MyForm.prepare(formId, "docs", options, false);
		
		$('#'+formId).submit();

	},
	
	massStepsForm: function(rowSelection, docTypeStep){
		
		var docTypeStep				= docTypeStep == undefined ? 'N' : docTypeStep;
		var currentListingDocType	= $("input[name='listingDocType']").val();
		var currentListingName		= $("input[name='listingName']").val();
		
		
		var title = Loc.g("Forcer les statuts de documents en masse");
		
		if (docTypeStep == "Y"){
			title = Loc.g("Forcer l'état de documents en masse");
		}
		
		var options = {
			title	: title,
			width: 1250,
			close: function(){
				Listing.update(currentListingName, false);
			},
			buttons	: [
                {
                    text : Loc.g("Fermer"), 
                    click : function(){
                        Utils.reload();
                    }
                },
                {
                    text : Loc.g("Forcer les statuts"), 	
                    'class' : 'btn btn-primary massFormBtn', 
                    click : function(){
                        DocMassSteps.processQueueSteps();
                    }
                }
            ],
            callback	: function(){
                MyFacture.customForm();	
            }
		};

		MyWindow.load("docs", {action:"massStepsForm",rowSelection:rowSelection,currentListingDocType:currentListingDocType, docTypeStep:docTypeStep }, options);
		
		
	},
	
};


window.DocIntegrityWorflowLogs = {
	
	prepareFilterForm: function(){
		var options = {success:function(data){DocIntegrityWorflowLogs.processFilterForm(data);}, dataType:"json"};
		MyForm.prepare("docIntregrityWorkflowLogsFilterForm", "docintegrityworkflow&action=updateListing", options);
	},
	
	processFilterForm: function(data){
		$("#docIntregrityWorkflowLogsListing_loading").fadeIn();
		Listing.refresh("docIntregrityWorkflowLogsListing", data, data.docIntregrityWorkflowLogs_metadatas);
	}
	
};

window.DocModels = {
	prepareFilterForm: function(){
		var options = {success:function(data){DocModels.processFilterForm(data);}, dataType:"json"};
		MyForm.prepare("docmodelsFilterForm", "models", options);
	},
	
	processFilterForm: function(data){
		$("#docmodelsListing_loading").fadeIn();
		Listing.refresh("docmodelsListing", data, data.docmodels_metadatas);
	}
};

window.DocEstimates = {
	prepareFilterForm: function(){
		var options = {success:function(data){DocEstimates.processFilterForm(data);}, dataType:"json"};
		MyForm.prepare("docestimatesFilterForm", "estimates", options);
	},
	
	processFilterForm: function(data){
		$("#docestimatesListing_loading").fadeIn();
		Listing.refresh("docestimatesListing", data, data.docestimates_metadatas);
	}
};

window.DocCreditnotes = {
	prepareFilterForm: function(){
		var options = {success:function(data){DocCreditnotes.processFilterForm(data);}, dataType:"json"};
		MyForm.prepare("doccreditnotesFilterForm", "creditnotes", options);
	},
	
	processFilterForm: function(data){
		$("#doccreditnotesListing_loading").fadeIn();
		Listing.refresh("doccreditnotesListing", data, data.doccreditnotes_metadatas);
	}
};

window.DocProformas = {
	prepareFilterForm: function(){
		var options = {success:function(data){DocProformas.processFilterForm(data);}, dataType:"json"};
		MyForm.prepare("docproformasFilterForm", "proformas", options);
	},
	
	processFilterForm: function(data){
		$("#docproformasListing_loading").fadeIn();
		Listing.refresh("docproformasListing", data, data.docproformas_metadatas);
	}
};

window.DocDeliveries = {
	prepareFilterForm: function(){
		var options = {success:function(data){DocDeliveries.processFilterForm(data);}, dataType:"json"};
		MyForm.prepare("docdeliveriesFilterForm", "deliveries", options);
	},
	
	processFilterForm: function(data){
		$("#docdeliveriesListing_loading").fadeIn();
		Listing.refresh("docdeliveriesListing", data, data.docdeliveries_metadatas);
	}
};

/**
 */
window.DocOrders = {
	prepareFilterForm: function(){
		var options = {success:function(data){DocOrders.processFilterForm(data);}, dataType:"json"};
		MyForm.prepare("docordersFilterForm", "orders", options);
	},
	
	processFilterForm: function(data){
		$("#docordersListing_loading").fadeIn();
		Listing.refresh("docordersListing", data, data.docorders_metadatas);
	}
};

/**
 * 
 */
window.DocInvoices = {
	prepareFilterForm: function(){
		var options = {success:function(data){DocInvoices.processFilterForm(data);}, dataType:"json"};
		var filterForm = 'docinvoicesFilterForm';
		MyForm.prepare(filterForm, "invoices", options);
		
	},
	
	processFilterForm: function(data){
		$("#docinvoicesListing_loading").fadeIn();
		Listing.refresh("docinvoicesListing", data, data.docinvoices_metadatas);
	},
	
	displayDetails: function(docid){
		var id = "detailsDisplayed_"+docid;
		var detailsDisplayed = Persistent.get(id, false);
		if("Y"==detailsDisplayed){
			$(".relatedTo_"+docid).each(function(){
				$(this).fadeOut();
			});
			Persistent.set(id, "N");
		} else {
			$(".relatedTo_"+docid).each(function(){
				$(this).fadeIn();
			});
			Persistent.set(id, "Y");
		}
	},
	
	createFromDeliveries: function(deliveriesId) {
		
		if(deliveriesId.length > 1) {
			var pursId = deliveriesId.join();
		}else {
			var pursId = deliveriesId.pop().split("_").pop();
		}
		
		Utils.relocate("?_f=invoiceForm&from="+pursId);
	}
};

window.PurDocOrders = {
	prepareFilterForm: function(){
		var options = {success:function(data){PurDocOrders.processFilterForm(data);}, dataType:"json"};
		var filterForm = 'purdocordersFilterForm';
		MyForm.prepare(filterForm, "purchases_purOrders", options);
		
	},
	
	processFilterForm: function(data){
		$("#purdocordersListing_loading").fadeIn();
		Listing.refresh("purdocordersListing", data, data.purdocorders_metadatas);
	},
	
	displayDetails: function(docid){
		var id = "detailsDisplayed_"+docid;
		var detailsDisplayed = Persistent.get(id, false);
		if("Y"==detailsDisplayed){
			$(".relatedTo_"+docid).each(function(){
				$(this).fadeOut();
			});
			Persistent.set(id, "N");
		} else {
			$(".relatedTo_"+docid).each(function(){
				$(this).fadeIn();
			});
			Persistent.set(id, "Y");
		}
	}
};

window.PurDocDeliveries = {
	prepareFilterForm: function(){
		var options = {success:function(data){PurDocDeliveries.processFilterForm(data);}, dataType:"json"};
		var filterForm = 'purdocdeliveriesFilterForm';
		MyForm.prepare(filterForm, "purchases_purDeliveries", options);
		
	},
	
	processFilterForm: function(data){
		$("#purdocdeliveriesListing_loading").fadeIn();
		Listing.refresh("purdocdeliveriesListing", data, data.purdocdeliveries_metadatas);
	},
	
	displayDetails: function(docid){
		var id = "detailsDisplayed_"+docid;
		var detailsDisplayed = Persistent.get(id, false);
		if("Y"==detailsDisplayed){
			$(".relatedTo_"+docid).each(function(){
				$(this).fadeOut();
			});
			Persistent.set(id, "N");
		} else {
			$(".relatedTo_"+docid).each(function(){
				$(this).fadeIn();
			});
			Persistent.set(id, "Y");
		}
	},
	
	createFromOrders: function(ordersIds) {
		
		var error = false;
		var suppliers = [];
		var nbSupplier = 0;
		
		$.each(ordersIds, function(e) {
			
			var infos = $("#more_infos_"+ordersIds[e]);
			
			if(infos.attr("deliverystep") != "wait") {
				error = true;
			}
			
			if(suppliers[infos.attr("supplier")] == undefined) {
				suppliers[infos.attr("supplier")] = 0;
				nbSupplier = nbSupplier+1;
			}
		});
		
		if(nbSupplier > 1) {
			error = true;
		}
		
		if(error) {
			MyWindow.alert(Loc.g("Il est impossible de fusionner des bons de commande déjà livré ou pour des fournisseurs différents."), {type:"error"});
		}else {
			
			if(ordersIds.length > 1) {
				var pursId = ordersIds.join();
			}else {
				var pursId = ordersIds.pop().split("_").pop();
			}

			Utils.relocate("?_f=purchases_purDeliveryForm&from="+pursId);
		}
		
	}
	
};

window.PurDocInvoices = {
	prepareFilterForm: function(){
		var options = {success:function(data){PurDocInvoices.processFilterForm(data);}, dataType:"json"};
		var filterForm = 'purdocinvoicesFilterForm';
		MyForm.prepare(filterForm, "purchases_purInvoices", options);
		
	},
	
	processFilterForm: function(data){
		$("#purdocinvoicesListing_loading").fadeIn();
		Listing.refresh("purdocinvoicesListing", data, data.purdocinvoices_metadatas);
	},
	
	displayDetails: function(docid){
		var id = "detailsDisplayed_"+docid;
		var detailsDisplayed = Persistent.get(id, false);
		if("Y"==detailsDisplayed){
			$(".relatedTo_"+docid).each(function(){
				$(this).fadeOut();
			});
			Persistent.set(id, "N");
		} else {
			$(".relatedTo_"+docid).each(function(){
				$(this).fadeIn();
			});
			Persistent.set(id, "Y");
		}
	},
	
	createFromDeliveries: function(deliveriesId) {
		
		var error = false;
		var suppliers = [];
		var nbSupplier = 0;
		
		$.each(deliveriesId, function(e) {
			
			var infos = $("#more_infos_"+deliveriesId[e]);
			
			if(infos.attr("step") != "draft") {
				error = true;
			}
			
			if(suppliers[infos.attr("supplier")] == undefined) {
				suppliers[infos.attr("supplier")] = 0;
				nbSupplier = nbSupplier+1;
			}
		});
		
		if(nbSupplier > 1) {
			error = true;
		}
		
		if(error) {
			MyWindow.alert(Loc.g("Il est impossible de fusionner des bons de livraison déjà facturés ou pour des fournisseurs différents."), {type:"error"});
		}else {
			
			if(deliveriesId.length > 1) {
				var pursId = deliveriesId.join();
			}else {
				var pursId = deliveriesId.pop().split("_").pop();
			}

			Utils.relocate("?_f=purchases_purInvoiceForm&from="+pursId);
		}
		
	}
};


window.PurDocCreditNotes = {
	prepareFilterForm: function () {
		var options = {
			success: function (data) {
				PurDocCreditNotes.processFilterForm(data);
			}, dataType: "json"};
		var filterForm = 'purdoccreditnotesFilterForm';
		MyForm.prepare(filterForm, "purchases_purCreditNotes", options);

	},
	
	processFilterForm: function (data) {
		$("#purdoccreditnotesListing_loading").fadeIn();
		Listing.refresh("purdoccreditnotesListing", data, data.purdoccreditnotes_metadatas);
	},
	
	
	displayDetails: function (docid) {
		var id = "detailsDisplayed_" + docid;
		var detailsDisplayed = Persistent.get(id, false);
		if ("Y" == detailsDisplayed) {
			$(".relatedTo_" + docid).each(function () {
				$(this).fadeOut();
			});
			Persistent.set(id, "N");
		} else {
			$(".relatedTo_" + docid).each(function () {
				$(this).fadeIn();
			});
			Persistent.set(id, "Y");
		}
	},
	
	createFromDeliveries: function (deliveriesId) {

		var error = false;
		var suppliers = [];
		var nbSupplier = 0;

		$.each(deliveriesId, function (e) {

			var infos = $("#more_infos_" + deliveriesId[e]);

			if (infos.attr("step") != "draft") {
				error = true;
			}

			if (suppliers[infos.attr("supplier")] == undefined) {
				suppliers[infos.attr("supplier")] = 0;
				nbSupplier = nbSupplier + 1;
			}
		});

		if (nbSupplier > 1) {
			error = true;
		}

		if (error) {
			MyWindow.alert(Loc.g("Il est impossible de fusionner des bons de livraison déjà facturés ou pour des fournisseurs différents."), {type: "error"});
		} else {

			if (deliveriesId.length > 1) {
				var pursId = deliveriesId.join();
			} else {
				var pursId = deliveriesId.pop().split("_").pop();
			}

			Utils.relocate("?_f=purchases_purInvoiceForm&from=" + pursId);
		}

	}
};